export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Gestión Cultural · Instituto Superior de Formación Técnica, Buenos Aires',
    'En una tarde tenía más material sobre gestión cultural contextualizado en Argentina que en toda mi carrera docente. Ahora mis alumnos me preguntan sobre el Fondo Nacional de las Artes, los derechos culturales en la Constitución, cómo se produce un festival con $500.000 pesos de presupuesto, cómo usar ChatGPT para formular proyectos, y tengo respuesta fundamentada para todo.',
    'bg-petrol',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Docente de Gestión Cultural · Instituto Técnico Superior, Santa Cruz',
    'Mis alumnos por primera vez entendieron la diferencia entre política cultural, institución cultural y proyecto cultural, y analizaron un caso real de un centro cultural comunitario del interior argentino con argumentos técnicos y marcos normativos vigentes. El nivel de participación se multiplicó.',
    'bg-deep',
  ],
  [
    'SP',
    'Sandra P.',
    'Profesora de Gestión Cultural · Instituto Superior, Córdoba',
    'Las simulaciones de formulación de proyectos con las plantillas del MEGAPACK son exactamente lo que mis alumnos necesitaban: presupuesto real, con organismos argentinos, con el FNA y el INT actualizados. Cambió todo.',
    'bg-teal',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Gestión Cultural',
    'Con el MEGAPACK, en una tarde tenía el argumento pedagógico completo para explicar por qué los derechos culturales están en la Constitución Nacional argentina, qué dice el artículo 75 inciso 19 sobre la responsabilidad del Estado en materia cultural, y por qué cada festival gratuito en una plaza existe porque alguien decidió que la cultura no puede ser solo para quienes pueden pagarla. Mis alumnos empezaron a ver la gestión cultural como una responsabilidad ciudadana. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Gestión Cultural',
    'Cuando explicás que la tragedia de Cromañón cambió para siempre la legislación de eventos en Argentina, que el organizador de un espectáculo tiene responsabilidad civil y penal por la seguridad del público, y que el aforo no es un capricho burocrático sino la diferencia entre una noche cultural y una tragedia, empieza un debate sobre ética y responsabilidad profesional que ninguna otra materia genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Gestión Cultural',
    'Cuando mis alumnos descubren que Argentina tiene más de 1.900 bibliotecas populares gestionadas por ciudadanos comunes, que son un fenómeno único en el mundo, que funcionan con subsidios mínimos y voluntad colectiva, y que representan el modelo más democrático de acceso a la cultura que existe en el país, empieza una conversación sobre el valor de lo comunitario que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Gestión Cultural',
    'Cerré la planificación anual en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con los organismos 2026, el marco normativo actualizado y los 150 proyectos del Bono 1 integrados en cada unidad didáctica.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack + Upsell Premium',
    'Cuando les digo a mis alumnos que el gestor cultural que trabaja en un municipio de 5.000 habitantes en La Rioja está haciendo lo mismo que los gestores de los grandes museos de Europa, que también está preservando patrimonio, garantizando derechos y cambiando vidas con cada taller y cada festival, y que eso tiene un nombre y una metodología que se puede aprender, les estoy enseñando lo que significa la responsabilidad cultural en el mundo real.',
  ],
];
